import React from 'react';
import { Button } from 'antd';

function AdnCancelButton({ onClick, text = 'Back' }) {
    return (
        <Button type="secondary" onClick={onClick} className="adn-outlined-button outlined-cancel">
            {text}
        </Button>
    );
}

export default AdnCancelButton;
